export enum ECredentialsType {
  ACCESS_CODE = "ACCESS_CODE",
  TOKEN = "TOKEN",
}
